import { RouteObject } from "react-router-dom";
import { EmailTemplatesList } from "../pages/admin/email-templates/EmailTemplatesList";
import { EmailTemplateDetail } from "../pages/admin/email-templates/EmailTemplateDetail";
import { EmailTemplateCreate } from "../pages/admin/email-templates/EmailTemplateCreate";
import { EmailTemplateEdit } from "../pages/admin/email-templates/EmailTemplateEdit";

export const emailTemplatesRoutes: RouteObject[] = [
  {
    id: "email-templates-list",
    index: true,
    element: <EmailTemplatesList />,
  },
  {
    id: "email-template-detail",
    path: ":id",
    element: <EmailTemplateDetail />,
  },
  {
    id: "email-template-create",
    path: "create",
    element: <EmailTemplateCreate />,
  },
  {
    id: "email-template-edit",
    path: ":id/edit",
    element: <EmailTemplateEdit />,
  },
];
